import { memo } from "react";

export const TextHighlight = memo(
  ({
    children,
    highlight,
  }: {
    children: string;
    highlight?: string | undefined;
  }) => {
    if (!highlight || highlight === "") {
      return <>{children}</>;
    }

    const lowerChildren = children.toLowerCase();
    const lowerHighlight = highlight.toLowerCase();
    const index = lowerChildren.indexOf(lowerHighlight);

    if (index === -1) {
      return <>{children}</>;
    }

    return (
      <div className="whitespace-pre">
        {children.slice(0, Math.max(0, index))}
        <strong>{children.slice(index, index + highlight.length)}</strong>
        {children.slice(Math.max(0, index + highlight.length))}
      </div>
    );
  },
);

TextHighlight.displayName = "TextHighlight";
